import { getTranslation } from '@easy-expense/intl-client';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';

import { SearchDropdown } from '../Shared/Dropdown/SearchDropDown.component';

const SORT_SUGGESTIONS: {
  key: string;
  value: { name: string; iconicIcon: 'calendar-outline' };
}[] = [
  { key: 'desc', value: { name: 'Descending', iconicIcon: 'calendar-outline' } },
  { key: 'asc', value: { name: 'Ascending', iconicIcon: 'calendar-outline' } },
];

export const SortCreatedAt: React.FC<{
  initialSortingState: 'desc' | 'asc' | undefined;
  setSorted: (createdAt: 'desc' | 'asc' | undefined) => void;
}> = ({ initialSortingState = undefined, setSorted }) => {
  const [sortedKey, setSortedKeyState] = React.useState<'desc' | 'asc' | undefined>(
    initialSortingState,
  );

  function wrapSetSorted(key: 'desc' | 'asc' | undefined) {
    setSortedKeyState(key);
    setSorted(
      (SORT_SUGGESTIONS.find((c) => c.key === key)?.key || undefined) as 'desc' | 'asc' | undefined,
    );
  }

  return (
    <Layout.Column>
      <Layout.Row align>
        <OpenSans.Primary size={22} weight="bold-700">
          {getTranslation('Created At Date')}
        </OpenSans.Primary>
      </Layout.Row>
      <Spacer.Vertical size={8} />
      <Layout.Row align>
        <SearchDropdown
          header={getTranslation('Sort by')}
          placeholder={'Select'}
          selectedKey={sortedKey}
          autoCompleteValues={[
            {
              key: undefined,
              value: { name: 'Select', iconicIcon: 'calendar-outline' },
            },
            ...SORT_SUGGESTIONS,
          ]}
          onSelect={(c) => {
            console.log('Selected sort key:', c?.key);
            wrapSetSorted(c?.key as 'desc' | 'asc' | undefined);
          }}
          error={false}
          iconicIcon="calendar-outline"
          clearOnSelect={true}
        />
      </Layout.Row>
    </Layout.Column>
  );
};
